import { isLaunchpadSupported, launchpadDefinitions } from '@/constants/launchpads';

import { LaunchpadAvatar } from '@/ui/Avatars/LaunchpadAvatar';
import { BadgeTooltip } from '@/ui/Badge/BadgeTooltip';

type TokenLaunchpadBadgeProps = {
  /** ID of the launchpad */
  id: string;
  /** Additional classes for the component */
  className?: string;
};

export const TokenLaunchpadBadge = ({ className, id }: TokenLaunchpadBadgeProps) => {
  const launchpadName = isLaunchpadSupported(id) ? launchpadDefinitions[id].name : id;

  return (
    <BadgeTooltip
      name={launchpadName}
      label={`Launchpad: ${launchpadName}`}
      tooltip={`Launched on ${launchpadName}`}
      icon={<LaunchpadAvatar id={id} alt="" size={16} />}
      className={className}
    />
  );
};
